import React, { useState, useEffect } from "react";
import { ItemMenu } from "../../components/Service";
import Service from "../../models/Service";
import { loadServiceItems } from "../../utils/helper-function"

const Food: React.FC = () => {
  const [foods, setFoods] = useState<Service[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const loadFoods = async () => {
      const [foods, categories] = await loadServiceItems("foods");
      setFoods(foods);
      setCategories(categories);
    };
    loadFoods();
  }, []);

  return (
    <ItemMenu title="Foods" items={foods} categories={categories} />
  );
};

export default Food;